import { APIService } from 'src/app/service/api.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Alliance } from 'src/app/model/alliance';

@Injectable({
  providedIn: 'root',
})
export class AllianceService {
  private allianceSource = new BehaviorSubject<Alliance>(undefined);
  alliance = this.allianceSource.asObservable();

  constructor(private apiService: APIService) {}

  setAlliance(alliance: Alliance) {
    return this.allianceSource.next(alliance);
  }

  get(origin: string): Observable<Alliance> {
    return this.apiService.get<Alliance>(`/api/alliances/${encodeURIComponent(origin)}`);
  }

  getAll(): Observable<Alliance[]> {
    return this.apiService.get<Alliance[]>('/api/alliances');
  }

  update(id: number, data: Partial<Alliance>): Observable<Alliance> {
    return this.apiService.put<Alliance>(`/api/alliances/${id}`, data);
  }
}
